import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'src/store';
import isUndefined from 'lodash/isUndefined';
import {
  getRequestCancelReservation,
  IMenuState,
  IReservationCancellationState,
} from 'src/store/slices/index';
import { SkeletonReviewBook } from 'src/components/components/index';
import {
  CancellationFailed,
  CancellationLink,
  CancellationNotAvailable,
  ErrorRequestCancel,
} from '../notification';
import { ReservationCancellationRoomInfo } from '../reservation-cancellation-room-info';
import './style.scss';

interface IMapStateProps {
  reservationCancellationStore: IReservationCancellationState;
  menuStore: IMenuState;
}

interface IMapDispatchToProps {
  getRequestCancelReservation: (key: string) => void;
}

interface IProps extends IMapStateProps, IMapDispatchToProps {}

interface IState {
  isGetCancellationLink: boolean;
}

const ZERO = 0;

export class RequestCancelReservationComponent extends React.Component<IProps, IState> {
  state: IState = {
    isGetCancellationLink: false,
  };

  onClickCancellationLink = (): void => {
    const params = new URLSearchParams(window.location.search);
    const tempKey = params.get('key');

    this.props.getRequestCancelReservation(tempKey);
    this.setState({ isGetCancellationLink: true });
  };

  render(): React.ReactNode {
    const { isGetCancellationLink } = this.state;
    const { reservationCancellationStore, menuStore } = this.props;
    const {
      requestCancelReservation,
      loadingRequestCancelReservation,
      errorRequestCancelReservation,
    } = reservationCancellationStore;

    return (
      <div className="request-cancel-reservation-wrapper">
        {!isGetCancellationLink ? (
          <CancellationLink
            isGetCancellationLink={isGetCancellationLink}
            onClickCancellationLink={this.onClickCancellationLink}
          />
        ) : null}
        {isGetCancellationLink && loadingRequestCancelReservation ? <SkeletonReviewBook /> : null}
        {isGetCancellationLink && requestCancelReservation && !loadingRequestCancelReservation ? (
          <div
            className={`request-cancel-reservation-wrapper__wrapper
            ${isUndefined(requestCancelReservation.reservationDetails) ? 'flex-center' : ''}`}
          >
            {requestCancelReservation.isCancellable ? (
              <CancellationLink isGetCancellationLink={isGetCancellationLink} />
            ) : requestCancelReservation?.isTryAgainLater ? (
              <CancellationFailed
                isTryAgainLater={requestCancelReservation?.isTryAgainLater}
                supportPhone={requestCancelReservation.supportPhone}
              />
            ) : (
              <CancellationNotAvailable isMemberType={menuStore.error.length === ZERO} />
            )}
            {!isUndefined(requestCancelReservation.reservationDetails) ? (
              <ReservationCancellationRoomInfo
                hotelDetails={requestCancelReservation.reservationDetails}
                isPromo={menuStore.items?.promo}
              />
            ) : null}
          </div>
        ) : null}
        {errorRequestCancelReservation.length !== ZERO && !loadingRequestCancelReservation ? (
          <ErrorRequestCancel />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateProps => {
  return {
    reservationCancellationStore: state.reservationCancellationStore,
    menuStore: state.navigationMenuStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getRequestCancelReservation,
};

export const RequestCancelReservationWrapper = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequestCancelReservationComponent);
